// client/src/components/Layout/Footer.js
import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  IconButton,
  Divider,
  Fade
} from '@mui/material';
import {
  Facebook,
  Twitter,
  LinkedIn,
  Phone,
  Email,
  LocationOn,
  Gavel,
  HomeWork,
  Description,
  Assignment,
  CleaningServices,
  Security,
  ArrowUpward
} from '@mui/icons-material';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    window.scrollTo({ top: document.documentElement.scrollHeight, behavior: 'smooth' });
  };

  return (
    <>
      <Box
        component="footer"
        sx={{
          background: 'linear-gradient(135deg, #0d1b52 0%, #1a237e 50%, #0d1b52 100%)',
          color: 'white',
          py: 6,
          mt: 'auto',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        {/* Décoration de fond */}
        <Box
          sx={{
            position: 'absolute',
            top: -100,
            right: -100,
            width: 300,
            height: 300,
            background: 'radial-gradient(circle, rgba(255,152,0,0.1) 0%, rgba(255,152,0,0) 70%)',
            borderRadius: '50%',
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            bottom: -100,
            left: -100,
            width: 250,
            height: 250,
            background: 'radial-gradient(circle, rgba(255,152,0,0.08) 0%, rgba(255,152,0,0) 70%)',
            borderRadius: '50%',
          }}
        />

        <Container maxWidth="lg">
          <Grid container spacing={4}>
            {/* Colonne 1: Présentation */}
            <Grid size={{ xs: 12, md: 4 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <img 
                  src="/logo2.png" 
                  alt="AUJAA GROUP" 
                  style={{ width: 45, height: 'auto', marginRight: 12 }}
                />
                <Typography variant="h5" fontWeight="bold" sx={{ 
                  background: 'linear-gradient(135deg, #fff, #ffb74d)',
                  backgroundClip: 'text',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}>
                  AUJAA GROUP
                </Typography>
              </Box>
              <Typography variant="body2" sx={{ lineHeight: 1.8, opacity: 0.85, mb: 2 }}>
                Clinique juridique spécialisée offrant des services complets
                en droit des affaires, immobilier, recouvrement, marchés publics,
                prestations de nettoyage, sécurité et formalités administratives.
              </Typography>
              <Box sx={{ display: 'flex', gap: 1, mt: 2 }}>
                <IconButton 
                  href="https://facebook.com" 
                  target="_blank"
                  sx={{ 
                    color: 'white', 
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    '&:hover': { backgroundColor: '#1877F2', transform: 'translateY(-3px)' },
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Facebook />
                </IconButton>
                <IconButton 
                  href="https://twitter.com" 
                  target="_blank"
                  sx={{ 
                    color: 'white', 
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    '&:hover': { backgroundColor: '#1DA1F2', transform: 'translateY(-3px)' },
                    transition: 'all 0.3s ease'
                  }}
                >
                  <Twitter />
                </IconButton>
                <IconButton 
                  href="https://linkedin.com" 
                  target="_blank"
                  sx={{ 
                    color: 'white', 
                    backgroundColor: 'rgba(255,255,255,0.1)',
                    '&:hover': { backgroundColor: '#0077B5', transform: 'translateY(-3px)' },
                    transition: 'all 0.3s ease'
                  }}
                >
                  <LinkedIn />
                </IconButton>
              </Box>
            </Grid>

            {/* Colonne 2: Liens rapides */}
            <Grid size={{ xs: 12, sm: 6, md: 2 }}>
                          <Typography variant="h5" fontWeight="bold" sx={{ 
              background: 'linear-gradient(135deg, #fff, #ffb74d)',
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb:2,
            }}>
                Navigation
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                <li><Link href="/" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}>Accueil</Link></li>
                <li><Link href="/about" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}>À propos</Link></li>
                <li><Link href="/services" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}>Services</Link></li>
                <li><Link href="/contact" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}>Contact</Link></li>
                <li><Link href="/consultation" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}>Consultation</Link></li>
              </Box>
            </Grid>

            {/* Colonne 3: Services */}
            <Grid size={{ xs: 12, sm: 6, md: 3 }}>
              <Typography variant="h5" fontWeight="bold" sx={{ 
  background: 'linear-gradient(135deg, #fff, #ffb74d)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  mb:2,
}}>
                Nos Services
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
                <li><Link href="/consultation" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><Gavel sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Consultation juridique</Link></li>
                <li><Link href="/recouvrement" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><Description sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Recouvrement de créances</Link></li>
                <li><Link href="/immobilier" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><HomeWork sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Services immobiliers</Link></li>
                <li><Link href="/consultation" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><Assignment sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Montage DAO</Link></li>
                <li><Link href="/consultation" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><CleaningServices sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Nettoyage & Entretien</Link></li>
                <li><Link href="/consultation" color="inherit" underline="hover" sx={{ display: 'block', mb: 1, opacity: 0.85, '&:hover': { opacity: 1, color: '#ff9800' } }}><Security sx={{ fontSize: 14, mr: 0.5, verticalAlign: 'middle' }} /> Sécurité & Gardiennage</Link></li>
              </Box>
            </Grid>

            {/* Colonne 4: Contact */}
            <Grid size={{ xs: 12, md: 3 }}>
              <Typography variant="h5" fontWeight="bold" sx={{ 
  background: 'linear-gradient(135deg, #fff, #ffb74d)',
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  mb:2,
}}>
                Contact
              </Typography>
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'flex-start', gap: 1 }}>
                <LocationOn sx={{ color: '#ff9800', mt: 0.3 }} />
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  Tokoin Forever, Lomé - Togo
                </Typography>
              </Box>
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Phone sx={{ color: '#ff9800' }} />
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  +228 90 35 87 66 / 99 54 90 41
                </Typography>
              </Box>
              <Box sx={{ mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                <Email sx={{ color: '#ff9800' }} />
                <Typography variant="body2" sx={{ opacity: 0.85 }}>
                  aujaagroup@gmail.com
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Divider sx={{ my: 4, backgroundColor: 'rgba(255,255,255,0.15)' }} />

          {/* Bas de footer */}
          <Grid container justifyContent="space-between" alignItems="center" spacing={2}>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="body2" sx={{ opacity: 0.7, textAlign: { xs: 'center', md: 'left' } }}>
                © {new Date().getFullYear()} AUJAA GROUP - Clinique Juridique. Tous droits réservés.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }}>
              <Typography variant="body2" sx={{ opacity: 0.6, textAlign: { xs: 'center', md: 'right' }, fontSize: '0.7rem' }}>
                #DryscoKad | Version 1.010
              </Typography>
            </Grid>
          </Grid>
        </Container>
      </Box>

      {/* Bouton flottant animé pour haut/bas de page */}
      <FloatingScrollButton scrollToTop={scrollToTop} scrollToBottom={scrollToBottom} />
    </>
  );
};

// Composant bouton flottant avec animation
const FloatingScrollButton = ({ scrollToTop, scrollToBottom }) => {
  const [isAtBottom, setIsAtBottom] = React.useState(false);
  const [isHovered, setIsHovered] = React.useState(false);

  React.useEffect(() => {
    const handleScroll = () => {
      const isBottom = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight - 100;
      setIsAtBottom(isBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = () => {
    if (isAtBottom) {
      scrollToTop();
    } else {
      scrollToBottom();
    }
  };

  return (
    <Box
      onClick={handleClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      sx={{
        position: 'fixed',
        bottom: 30,
        right: 30,
        zIndex: 1000,
        cursor: 'pointer',
        animation: 'float 2s ease-in-out infinite',
        transition: 'all 0.3s ease',
        transform: isHovered ? 'scale(1.1)' : 'scale(1)',
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #1a237e, #283593)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 4px 15px rgba(0,0,0,0.3)',
          transition: 'all 0.3s ease',
          border: '2px solid rgba(255,152,0,0.5)',
          '&:hover': {
            background: 'linear-gradient(135deg, #ff9800, #ffb74d)',
            boxShadow: '0 6px 20px rgba(255,152,0,0.4)',
          },
        }}
      >
        {isAtBottom ? (
          <ArrowUpward sx={{ color: 'white', fontSize: 28, animation: 'pulse 1s infinite' }} />
        ) : (
          <Box sx={{ position: 'relative' }}>
            <ArrowUpward 
              sx={{ 
                color: 'white', 
                fontSize: 24, 
                transform: 'rotate(180deg)',
                animation: 'bounceDown 1s infinite'
              }} 
            />
          </Box>
        )}
      </Box>
      {/* Tooltip flottant */}
      <Fade in={isHovered}>
        <Box
          sx={{
            position: 'absolute',
            bottom: 70,
            right: 10,
            backgroundColor: 'rgba(0,0,0,0.8)',
            color: 'white',
            padding: '4px 12px',
            borderRadius: 20,
            fontSize: '12px',
            whiteSpace: 'nowrap',
            pointerEvents: 'none',
          }}
        >
          {isAtBottom ? '⬆️ Retour en haut' : '⬇️ Aller en bas'}
        </Box>
      </Fade>

      {/* Ajout des animations CSS manquantes */}
      <style>{`
        @keyframes bounceDown {
          0%, 100% { transform: rotate(180deg) translateY(0); }
          50% { transform: rotate(180deg) translateY(8px); }
        }
      `}</style>
    </Box>
  );
};

export default Footer;